var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39961 7.82177C5.27077 7.82177 5.14194 7.77278 5.04397 7.67414C4.54874 7.17959 4.27563 6.52198 4.27563 5.82276C4.27563 4.37334 5.45397 3.19434 6.90205 3.19434C7.59858 3.19434 8.27498 3.4755 8.75745 3.96602C8.95205 4.16465 8.95004 4.48272 8.75141 4.67731C8.55346 4.87326 8.23539 4.8699 8.04012 4.67262C7.74554 4.37267 7.33084 4.20088 6.90205 4.20088C6.00891 4.20088 5.28218 4.92828 5.28218 5.82276C5.28218 6.2529 5.45061 6.6582 5.75526 6.96285C5.95187 7.15946 5.95187 7.47753 5.75593 7.67414C5.65729 7.77278 5.52845 7.82177 5.39961 7.82177Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28302 8.408C7.0448 8.408 6.83275 8.23756 6.78847 7.99464C6.73881 7.72153 6.91999 7.45916 7.19377 7.4095C7.85138 7.29006 8.3721 6.768 8.4902 6.10971C8.53986 5.8366 8.80156 5.65677 9.07467 5.70374C9.34845 5.75273 9.5303 6.01443 9.48131 6.28821C9.28873 7.35716 8.44189 8.20535 7.3736 8.39994C7.34341 8.40531 7.31254 8.408 7.28302 8.408Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5361_89522",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.191895 0.445312H10.9863V9.90559H0.191895V0.445312Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5361_89522)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31521 9.90559C3.2065 9.90559 3.09712 9.87003 3.00452 9.79823C1.86981 8.9071 0.910904 7.6006 0.233163 6.02099C0.178138 5.8935 0.178138 5.7499 0.233163 5.62307C0.918286 4.03676 1.88323 2.72355 3.02398 1.82638C5.34978 -0.0142584 8.44591 -0.0202977 10.7952 1.8398C11.0133 2.01226 11.0502 2.32898 10.8777 2.54707C10.7046 2.76381 10.3892 2.80206 10.1705 2.62893C8.18018 1.05335 5.61617 1.05872 3.64737 2.61685C2.68377 3.37512 1.85639 4.47964 1.24575 5.82304C1.85035 7.15839 2.67035 8.2562 3.62657 9.00641C3.84532 9.17819 3.8829 9.49492 3.71112 9.71301C3.6118 9.83916 3.46418 9.90559 3.31521 9.90559Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5361_89522",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 10,
    height: 9
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69946 3.20801H13.6125V11.2256H4.69946V3.20801Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5361_89522)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90221 11.2256C6.27345 11.2256 5.64805 11.1236 5.04413 10.923C4.78041 10.8351 4.63748 10.5499 4.72539 10.2862C4.81329 10.0218 5.09714 9.88155 5.36219 9.96744C5.86345 10.1345 6.38149 10.2191 6.90221 10.2191C9.20251 10.2191 11.3048 8.58042 12.559 5.82181C12.253 5.15145 11.8967 4.54417 11.4981 4.01405C11.331 3.79194 11.3753 3.47589 11.5974 3.3088C11.8189 3.14171 12.1349 3.18734 12.302 3.40878C12.7878 4.05364 13.2146 4.79916 13.5709 5.62184C13.6266 5.74934 13.6266 5.89428 13.5709 6.02111C12.1644 9.2803 9.67156 11.2256 6.90221 11.2256Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5361_89522",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 12,
    height: 12
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10693 0.0263672H12.698V11.6171H1.10693V0.0263672Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5361_89522)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.61004 11.6166C1.4812 11.6166 1.35236 11.5676 1.25439 11.469C1.05778 11.2724 1.05778 10.9543 1.25439 10.7577L11.8392 0.17285C12.0358 -0.0237624 12.3539 -0.0237624 12.5505 0.17285C12.7471 0.369462 12.7471 0.688202 12.5505 0.884814L1.96569 11.469C1.86772 11.5676 1.73888 11.6166 1.61004 11.6166Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.b906c1bd4ed1e77ea5bda79eeb71065e.svg";
export { ForwardRef as ReactComponent };